import React, { useState } from "react";
import "./index.css";
import { Layout, Menu, Divider, Modal, Typography, Card } from "antd";
import {
  UserOutlined,
  EnvironmentOutlined,
  LogoutOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import I18n from "../../i18n";
import Orders from "./components/Orders";
import Addresses from "./components/Addresses";
import AccountInfo from "./components/AccountInfo";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { useAppDispatch } from "../../../application/store";
import { logOut } from "../../../application/auth-slice";
import { DocumentTitle } from "../../components";

const { Sider, Content } = Layout;

type RouteParams = { activeTab: "" | "addresses" | "orders" };

export default function Profile() {
  const dispatch = useAppDispatch();
  const { activeTab } = useParams<RouteParams>();
  const history = useHistory();
  const [logOutModalVisible, setLogOutModalVisible] = useState(false);

  const showLogOutModal = () => setLogOutModalVisible(true);
  const closeLogOutModal = () => setLogOutModalVisible(false);
  const onLogOut = () => {
    closeLogOutModal();
    dispatch(logOut());
    history.push("/");
  };

  const renderActiveTab = () => {
    if (activeTab === "orders") return <Orders />;
    if (activeTab === "addresses") return <Addresses />;
    return <AccountInfo />;
  };

  const renderMenu = () => {
    const selectedLeys = isMobile
      ? []
      : [activeTab === "" || activeTab === undefined ? "account" : activeTab];

    return (
      <Card
        className={isMobile ? "profile-card-mobile" : ""}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={selectedLeys}
          className="profile-menu"
        >
          <Menu.Item
            key="account"
            icon={<UserOutlined />}
            onClick={() => history.push("/profile/account/")}
          >
            {I18n.profile.tabs.accountInfo}
          </Menu.Item>
          <Menu.Item
            key="addresses"
            icon={<EnvironmentOutlined />}
            onClick={() => history.push("/profile/addresses/")}
          >
            {I18n.profile.tabs.addresses}
          </Menu.Item>
          <Menu.Item
            key="orders"
            icon={<ShoppingOutlined />}
            onClick={() => history.push("/profile/orders/")}
          >
            {I18n.profile.tabs.orders}
          </Menu.Item>
          <Divider />
          <Menu.Item icon={<LogoutOutlined />} onClick={showLogOutModal} danger>
            {I18n.profile.logOut}
          </Menu.Item>
        </Menu>
      </Card>
    );
  };

  const isProfileFirstPage = activeTab === "" || activeTab === undefined;
  return (
    <DocumentTitle title={I18n.profile.title}>
      <MobileView>
        {isProfileFirstPage && isMobile ? (
          renderMenu()
        ) : (
          <Content className="profile-content-mobile">
            {renderActiveTab()}
          </Content>
        )}
      </MobileView>

      <BrowserView>
        <Layout>
          <Sider className="profile-sider">{renderMenu()}</Sider>
          <Content className="profile-content-desktop">
            {renderActiveTab()}
          </Content>
        </Layout>
      </BrowserView>

      <Modal
        title={I18n.profile.logOutConfirmModal.title}
        visible={logOutModalVisible}
        onOk={onLogOut}
        onCancel={closeLogOutModal}
      >
        <Typography.Text>
          {I18n.profile.logOutConfirmModal.description}
        </Typography.Text>
      </Modal>
    </DocumentTitle>
  );
}
